module.exports = __webpack_public_path__ + "media/images/course/__depo_03-b6fffd7c9c9211f7fdf9b6393631bb97.png";